<template>
	<div class="bg">
		<!-- 搜索栏 -->
		<div class="top_search_part">
			<div class="search_box">
				<div class="search_item"><el-input v-model="customerName" :placeholder="$t('message.custSearchPlaceholder1')"></el-input></div>
				<div class="search_btn" @click="searchCustomerName">{{ $t('message.searchBtnText') }}</div>
			</div>
			<div class="add_btn" @click="addNewCustomer">
				<img class="add_icon" src="@/assets/addIcon.svg" />
				{{ $t('message.addCustBtnText') }}
			</div>
		</div>
		<!-- 搜索栏 -->
		<!-- 列表 -->
		<!-- 客户管理列表 -->
		<div class="content">
			<div class="tableBox">
				<el-table id="customerList" :data="customerList" style="width: 100%" stripe size="small" header-cell-class-name="tableHeader" cell-class-name="tableBodyer" height="100%">
					<el-table-column :label="$t('message.customTableTitle1')" prop="index" width="85"></el-table-column>
					<el-table-column :label="$t('message.customTableTitle2')" prop="USHOWNAME" min-width="120"></el-table-column>
					<el-table-column :label="$t('message.newCustomerPhone')" prop="TELPHONE" min-width="120"></el-table-column>
						
					<el-table-column :label="$t('message.newCustomerCompany')" prop="GUDING1" min-width="150"></el-table-column>
					<el-table-column :label="$t('message.newCustomerEmail')" prop="GUDING2" min-width="160"></el-table-column>
					<el-table-column :label="$t('message.newCustomerProvince')" prop="GUDING3" width="120"></el-table-column>
					<el-table-column :label="$t('message.newCustomerCity')" prop="GUDING4" width="120"></el-table-column>
					<el-table-column :label="$t('message.newCustomerDetailAddress')" prop="GUDING5" min-width="200"></el-table-column>
					<el-table-column :label="$t('message.customTableTitle5')" width="150" fixed="right">						
						<template slot-scope="scope">
							<div class="operate_btn_box">
								<el-button class="operation_btn updateBtn" type="text" size="small" @click.native.prevent="updateCustomer(scope.row)"></el-button>
								<el-button class="operation_btn delBtn" type="text" size="small" @click.native.prevent="delCustomer(scope.row)"></el-button>
							</div>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<el-pagination
				@size-change="sizeChange"
				@current-change="currentChange"
				:current-page="page_no"
				:page-sizes="pageSizes"
				:page-size="page_size"
				layout="total, sizes, prev, pager, next"
				:total="totalSize"
				class="tablePage"
			></el-pagination>
		</div>
		<!-- 客户管理列表 -->
		<!-- 列表 -->
		<el-dialog :visible.sync="newCustomer" :title="dialogTitle" destroy-on-close :close-on-click-modal="false" center :modal-append-to-body="false" width="55%">
			<div class="dialog_box">
				<div class="dialog_row">
					<div class="dialog_item">
						<span class="dialog_item_title">{{ $t('message.newCustomerName') }}</span>
						<el-input v-model="newCustomerName" :placeholder="$t('message.placeholder')"></el-input>
					</div>
					<div class="dialog_item">
						<span class="dialog_item_title">{{ $t('message.newCustomerLoginName') }}</span>
						<el-input v-model="newCustomerLoginName" :placeholder="$t('message.placeholder')"></el-input>
					</div>
				</div>
				<div class="dialog_row">
					<div class="dialog_item">
						<span class="dialog_item_title">{{ $t('message.newCustomerPhone') }}</span>
						<el-input v-model="newCustomerPhone" :placeholder="$t('message.placeholder')"></el-input>
					</div>
					<div class="dialog_item">
						<span class="dialog_item_title">{{ $t('message.newCustomerPassword') }}</span>
						<el-input v-model="newCustomerPassword" :placeholder="$t('message.placeholder')"></el-input>
					</div>
				</div>
				<div class="dialog_row">
					<div class="dialog_item">
						<span class="dialog_item_title">{{ $t('message.newCustomerCompany') }}</span>
						<el-input v-model="newCustomerCompany" :placeholder="$t('message.placeholder')"></el-input>
					</div>
					<div class="dialog_item">
						<span class="dialog_item_title">{{ $t('message.newCustomerEmail') }}</span>
						<el-input v-model="newCustomerEmail" :placeholder="$t('message.placeholder')"></el-input>
					</div>
				</div>
				<div class="dialog_row">
					<div class="dialog_item">
						<span class="dialog_item_title">{{ $t('message.newCustomerProvince') }}</span>
						<el-input v-model="newCustomerProvince" :placeholder="$t('message.placeholder')"></el-input>
					</div>
					<div class="dialog_item">
						<span class="dialog_item_title">{{ $t('message.newCustomerCity') }}</span>
						<el-input v-model="newCustomerCity" :placeholder="$t('message.placeholder')"></el-input>
					</div>
				</div>
				<div class="dialog_row">
					<div class="dialog_item">
						<span class="dialog_item_title">{{ $t('message.newCustomerDetailAddress') }}</span>
						<el-input v-model="newCustomerDetailAddress" :placeholder="$t('message.placeholder')"></el-input>
					</div>
				</div>
				<span slot="footer" class="dialog-footer">
					<el-button @click="newCustomer = false">{{ $t('message.cancleText') }}</el-button>
					<el-button type="primary" @click="addNewConfirm">{{ $t('message.confirmText') }}</el-button>
				</span>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import { getCustomer, setCustomer, delCustomer } from '@/api/getData.js';
import prefectures from '@/js/prefectures.json';
export default {
	name: 'customerManagePage',
	data() {
		return {
			page_no: 1,
			page_size: 10,
			pageSizes: [10, 20, 30, 50, 100],
			totalSize: 0,
			prefecturesList: [],
			customerList: [],
			customerName: '',
			newCustomer: false,
			dialogTitle: '',
			newId: 0,
			newCustomerName: '',
			newCustomerLoginName: '',
			newCustomerPhone: '',
			newCustomerPassword: '',
			newCustomerCompany: '',
			newCustomerEmail: '',
			newCustomerProvince: '',
			newCustomerCity: '',
			newCustomerDetailAddress: '',
			newCustomerIsAdmin: '0',
			newCustomerSpecial: '',
			newCustomerIsDriverAdmin: '0',
			newCustomerIsDriverPosition: '',
			selPermission: []
		};
	},
	created() {
		this.prefecturesList = prefectures;
		let param = this.$store.state.JHSS_customer_param;
		console.log('输出a', this.$store.state.JHSS);
		if (param.PAGE) this.page_no = param.PAGE;
		if (param.TYPE) this.page_size = param.TYPE;
		if (param.USHOWNAME) this.customerName = param.USHOWNAME;
		// 查询客户列表
		this.getCustomer(param);
	},
	methods: {
		// 查询客户列表
		async getCustomer(param) {
			const loading = this.$loading({
				lock: true,
				text: 'Loading',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.7)'
			});
			param = param || {};
			param.PAGE = this.page_no;
			param.TYPE = this.page_size;
			param.ADDUSERID=this.$store.state.JHSS.personalUserid;
			let res = await getCustomer(param);
			loading.close();
			if (res.status !== 200) {
				this.$message.error('network error：' + res.status);
				return;
			}
			// console.log(res.data.ds)
			this.totalSize = res.data.num;
			let _this = this;
			let index = (this.page_no - 1) * this.page_size;
			this.customerList = res.data.dt.map(item => {
				item.index = ++index;
				item.password = '······';
				return item;
			});
			this.$store.commit('setCustomerParam', param);
		},
		// 搜索客户姓名
		searchCustomerName() {
			this.page_no = 1;
			let param = {};
			param.USHOWNAME = this.customerName;
			this.getCustomer(param);
		},
		// 申请条数
		sizeChange(val) {
			this.page_size = val;
			this.page_no = 1;
			let param = {};
			param.USHOWNAME = this.customerName;
			this.getCustomer(param);
		},
		// 当前页
		currentChange(val) {
			// console.log(val)
			this.page_no = val;
			let param = {};
			param.USHOWNAME = this.customerName;
			this.getCustomer(param);
		},
		// 添加客户
		addNewCustomer() {
			this.newId = 0;
			this.newCustomerName = '';
			this.newCustomerLoginName = '';
			this.newCustomerPhone = '';
			this.newCustomerPassword = '';
			this.newCustomerCompany = '';
			this.newCustomerEmail = '';
			this.newCustomerProvince = '';
			this.newCustomerCity = '';
			this.newCustomerDetailAddress = '';
			this.newCustomerIsAdmin = '0';
			this.newCustomerSpecial = '';
			this.newCustomerIsDriverAdmin = '0';
			this.newCustomerIsDriverPosition = '';
			this.selPermission = ["F17"];
			this.newCustomer = true;
			this.dialogTitle = this.$t('message.addCustBtnText');
		},
		// 确定添加客户
		async addNewConfirm() {
			if (!this.newCustomerName) {
				this.$message.error(this.$t('message.newCustomerName'));
			} else if (!this.newCustomerLoginName) {
				this.$message.error(this.$t('message.newCustomerLoginName'));
			} else if (!this.newCustomerPhone) {
				this.$message.error(this.$t('message.newCustomerPhone'));
			} else if (!this.newCustomerPassword) {
				this.$message.error(this.$t('message.newCustomerPassword'));
			} else if (!this.newCustomerCompany) {
				this.$message.error(this.$t('message.newCustomerCompany'));
			} else if (!this.newCustomerEmail) {
				this.$message.error(this.$t('message.newCustomerEmail'));
			} else if (!this.newCustomerProvince) {
				this.$message.error(this.$t('message.newCustomerProvince'));
			} else if (!this.newCustomerCity) {
				this.$message.error(this.$t('message.newCustomerCity'));
			} else if (!this.newCustomerDetailAddress) {
				this.$message.error(this.$t('message.newCustomerDetailAddress'));
			} else {
				const loading = this.$loading({
					lock: true,
					text: 'Loading',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.7)'
				});
				let param = {
					mod: {
						ID: this.newId,
						USHOWNAME: this.newCustomerName,
						PASSWORD: this.newCustomerPassword,
						UINPUTNAME: this.newCustomerLoginName,
						TELPHONE: this.newCustomerPhone,
						GUDING1: this.newCustomerCompany,
						GUDING2: this.newCustomerEmail,
						GUDING3: this.newCustomerProvince,
						GUDING4: this.newCustomerCity,
						GUDING5: this.newCustomerDetailAddress,
						GUDING10: this.newCustomerIsAdmin,
						TSSF: this.newCustomerSpecial,
						DRIVERADMIN: this.newCustomerIsDriverAdmin,
						DRIVERADDRESS: this.newCustomerIsDriverPosition,
						ADDUSERID: this.$store.state.JHSS.personalUserid
					},
					lst: this.selPermission
				};
				// console.log(param)
				let res = await setCustomer(param);
				loading.close();
				if (res.status !== 200) {
					this.$message.error('network error：' + res.status);
					return;
				}
				// console.log(res.data)
				if (res.data.result !== '1') {
					this.$message.error(res.data.message);
				} else {
					this.newCustomer = false;
					this.page_no = 1;
					this.getCustomer();
				}
			}
		},
		// 修改客户
		updateCustomer(obj) {
			// console.log(obj)
			this.newCustomer = true;
			this.dialogTitle = this.$t('message.updateCustBtnText');
			this.newId = obj.ID;
			this.newCustomerName = obj.USHOWNAME;
			this.newCustomerPassword = obj.PASSWORD;
			this.newCustomerLoginName = obj.UINPUTNAME;
			this.newCustomerPhone = obj.TELPHONE;
			this.newCustomerCompany = obj.GUDING1;
			this.newCustomerEmail = obj.GUDING2;
			this.newCustomerProvince = obj.GUDING3;
			this.newCustomerCity = obj.GUDING4;
			this.newCustomerDetailAddress = obj.GUDING5;
			this.newCustomerIsAdmin = obj.GUDING10; // !obj.USERID.includes('admin') ? '0' : '1'
			this.newCustomerSpecial = obj.TSSF;
			this.DRIVERADMIN = obj.DRIVERADMIN;
			this.DRIVERADDRESS = obj.DRIVERADDRESS;
			//this.selPermission = obj.LST.split(',');
		},
		// 删除客户
		delCustomer(obj) {
			// console.log(obj)
			this.$confirm(this.$t('message.prompt'), this.$t('message.promptTitle'), {
				closeOnClickModal: false,
				confirmButtonText: this.$t('message.confirmText'),
				cancelButtonText: this.$t('message.cancleText')
			})
				.then(() => {
					this.del(obj.ID);
				})
				.catch(() => {
					this.$message(this.$t('message.canclePrompt'));
				});
		},
		async del(id) {
			let param = { ID: id };
			let res = await delCustomer(param);
			if (res.status !== 200) {
				this.$message.error('network error：' + res.status);
				return;
			}
			if (res.data.result !== '1') {
				this.$message.error(res.data.message);
			} else {
				let param = { USHOWNAME: this.customerName };
				this.getCustomer(param);
			}
		}
	}
};
</script>

<style scoped>
.addItemInput {
	width: 280px;
	min-height: 46px;
	border: 1px solid #979797;
	border-radius: 4px;
	padding: 0 11px;
	font-size: 18px;
	color: #666666;
	text-align: left;
}
.dialog_item {
	max-width: 100%;
}
.checkboxGroup {
	display: flex;
	flex-flow: wrap;
}
</style>
